import React from 'react'
import PropTypes from 'prop-types'
import { useStaticQuery, graphql } from "gatsby"
import { Container, Row, Col } from '../../../components/ui/wrapper'
import Heading from '../../../components/ui/heading'
import Anchor from '../../../components/ui/anchor'
import ServiceBox from '../../../components/box-image/layout-six'
import { ServicesWrapper } from './services-area.style'
import BoxIcon from '../../../components/box-icon/layout-two'

const Services = ({ serviceBoxStyle, linkStyle, headingStyle }) => {
    const featuredDataQuery = useStaticQuery(graphql`
        query AboutServicesQueryData {
            allItServicesJson(
                sort: {id: DESC}
                filter: {is_featured: {eq: true}, is_active: {eq: true}}
                limit: 3
            ) {
                edges {
                node {
                    fields {
                    slug
                    }
                    id
                    title
                    excerpt
                    icon {
                    svg {
                        publicURL
                    }
                    }
                }
                }
            }
        }
    `);
    const services = featuredDataQuery.allItServicesJson.edges;
    return (
        <ServicesWrapper>
            <Container>
                <Row>
                    {services && services.map(service => (
                        <Col lg={4} md={6} className="box-item" key={service.node.id}>
                            <BoxIcon
                                id={service.node.id}
                                title={service.node.title}
                                desc={service.node.excerpt}
                                icon={service.node.icon}
                                path={`/services/${service.node.fields.slug}`}
                            />
                        </Col>
                    ))}
                </Row>
                <Row>
                    <Col lg={12}>
                        <Heading {...headingStyle}>We build customised solutions in the latest technologies based on your needs. <Anchor {...linkStyle} path="/contact-us">Get in touch!</Anchor></Heading>
                    </Col>
                </Row>
            </Container>
        </ServicesWrapper>
    )
}

Services.propTypes = {
    serviceBoxStyle: PropTypes.object,
    linkStyle: PropTypes.object,
    headingStyle: PropTypes.object,
}

Services.defaultProps = {
    serviceBoxStyle: {
        mb: "50px"
    },
    linkStyle: {
        layout: 'underline',
        hover: {
            layout: 2
        }
    },
    headingStyle: {
        as: 'h3',
        fontSize: '18px',
        fontweight: 500,
        lineHeight: 1.40,
        color: 'textColor',
        mt: '10px',
        textalign: 'center',
        responsive: {
            small: {
                mt: '5px'
            }
        }
    }
}

export default Services;